export default defineNuxtRouteMiddleware(async (to) => {
  devConsole.info("🛠️ ckAuth: middleware called", to.fullPath);

  const {
    $i18n: { t },
  } = useNuxtApp();
  const notification = useGlobalNotification();
  const {
    autoLoginQueryParam,
    providerNameQueryParam,
    initQueryParams,
    makeQueryParams,
    goToUnauthorizedRedirectPage,
    goHome,
  } = useAuthQueryParams();
  const { authStore, attemptLogin } = useAuthApi();

  await authStore.refresh();
  await initQueryParams();

  // if auto login on guest, attempt to login with provider
  if (!authStore.isAuthed && to.meta.allowAnonymous && autoLoginQueryParam.value) {
    const queryParams = makeQueryParams();
    await attemptLogin({
      loginHint: queryParams.loginHint,
      providerName: providerNameQueryParam.value,
    });
  }

  // If route needs user authenticated
  if (!authStore.isAuthed && !to.meta.allowAnonymous) {
    return goToUnauthorizedRedirectPage();
  }

  // show warning if the route allows anonymous access but the user is authenticated
  if (authStore.isAuthed && to.meta.allowAnonymous && to.meta.allowAnonymousWarningMessage) {
    notification.showWarning(t(to.meta.allowAnonymousWarningMessage));
  }

  // Strict anonymous access, only guest can access, if already authenticated, redirect to home page
  if (authStore.isAuthed && to.meta.allowAnonymous === "strict") {
    return goHome();
  }
});
